import React, { useState } from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { Modal as BootstrapModal, Tab } from 'react-bootstrap'
import { CRMIntegrationSettings } from '../CRMIntegrationSettings'
import { Tabs } from '../../../../components/Tabs/Tabs'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { ContactSyncSettings } from '../ContactSyncSettings'

export type SalesforceSettingsModalProps = {
  show: boolean
  onHide: () => void
}

export const SalesforceSettingsModal: React.FC<SalesforceSettingsModalProps> = ({ show, onHide }) => {
  const [activeTabKey, setActiveTabKey] = useState<string>('salesforceMappings')
  const changeTab = (key: string | null) => {
    if (key) {
      setActiveTabKey(key)
    }
  }

  const SalesforceSettingsModalBody = () => {
    return (
      <Tabs activeKey={activeTabKey} id='salesforce-settings' className='d-flex mb-3' onSelect={changeTab} mountOnEnter unmountOnExit>
        <Tab eventKey='salesforceMappings' title='Mappings'>
          <CRMIntegrationSettings serviceId='salesforce' onSaved={onHide} onCancelled={onHide} />
        </Tab>
        <Tab eventKey='salesforceSyncSettings' title='Contact Sync'>
          <ContactSyncSettings serviceId={'salesforce'} />
        </Tab>
        <Tab eventKey='salesforceTaskSettings' title='Tasks'>
          <CRMIntegrationTaskSettings serviceId='salesforce' />
        </Tab>
      </Tabs>
    )
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<BootstrapModal.Title>Edit Salesforce Integration Settings</BootstrapModal.Title>}
      body={<SalesforceSettingsModalBody />}
    />
  )
}
